import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Image from '../../../components/atom/image';
import { updateUrlDetailsForQuickInvest } from '../../../redux/actions/quickbuy';
import { cvlData, getCartCount } from '../../../redux/actions/trans/authAction';
import loginApi from '../../loginApi';
import ApiCall from '../../trans/trans';
import './shared.css';
import { getDecryptedItem, setEncryptedItem } from '../../../helper/methods';

let api = new loginApi();
let api2 = new ApiCall();
const Navbar = (props) => {
    const [show, setShow] = useState(false);
    const [PAN, setPAN] = useState('');
    const [ClientType, setClientType] = useState('');

    const dispatch = useDispatch()

    const stateData = useSelector(state => state.Auth);
    const history = useHistory();

    const gotoResetPasscode = () => {
        // let page_url = process.env.REACT_APP_MODE === "development" ?  : "/mutualfund/login/resetpasscode";
        // window.location.href = page_url;
        history.push("/login/resetpasscode");
    }

    const handleLogout = () => {
        //localStorage.setItem("pageUrl", 'quickbuy');
        props.logout();
    }

    const handleShow = () => {
        setShow(!show)
    }

    const closePOpUp = () => {
        let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
        console.log(getNavbar, 'getNavbar')
        getNavbar.forEach((curr) => {
            console.log(curr.childNodes, 'Sujeet')
            if (curr.childNodes[1] !== undefined) {
                curr.childNodes[1].classList.remove('show');
            }
        })
    }


    const redirectPurchasePage = () => {
        let urlParams = {
            singleAssetType: "All",
            fundCodeFromUrl: null,
            optionCodeFromUrl: null,
            planCodeFromUrl: null,
            isQuickInvestFromUrl: null,

            option: null,
            brokercode: null,
            subbrokercode: null,
            euinno: null,
            internalcode: null,
            utm_campaign: null,
        }
        dispatch(updateUrlDetailsForQuickInvest(urlParams));
        history.push("/quickbuy");
    }

    useEffect(() => {

        if (typeof window !== 'undefined') {

            async function setInitials() {
                let clientTypeArr = localStorage.getItem('ClientType');
                let panNoArr = getDecryptedItem("uniqueKey");

                if (!panNoArr || !clientTypeArr) {
                    // Call PAN from Token.
                    // Call CVL API.
                    // Call ClientType API.
                    // Set localstorage.
                    let CustPAN = "";
                    let getPayload = {
                        apiName: "GetPanFromToken",
                        params: ""
                    }
                    let apiResponsePAN = await api2.commonGet(getPayload);
                    console.log("apiResponsePAN =========", apiResponsePAN);
                    if (apiResponsePAN?.data?.success === true) {
                        CustPAN = apiResponsePAN?.data?.data;
                        let CVLpayload = {
                            "apiName": "kycCheck",
                            "body": { panNo: CustPAN }
                        };
                        let kycResponse = await api.common(CVLpayload);

                        let payloadClientType = {
                            "apiName": "clientType",
                            "body": { panNo: CustPAN }
                        };
                        let clientTypeResponse = await api.common(payloadClientType);

                        localStorage.setItem('ClientType', JSON.stringify(clientTypeResponse?.data));
                        setEncryptedItem("uniqueKey", { panNo: CustPAN, nameAsOnPan: kycResponse?.data?.data?.nameAsOnPan });
                    }
                }

                // let panNoArr = getDecryptedItem("uniqueKey');
                if (panNoArr) {
                    let jsonData = panNoArr;
                    setPAN(jsonData.panNo);
                }
                // let clientTypeArr = localStorage.getItem('ClientType');
                if (clientTypeArr) {
                    let clientJsonData = JSON.parse(clientTypeArr);
                    setClientType(clientJsonData.data.existingClient);
                }
            }
            setInitials();

            var localData = getDecryptedItem("uniqueKey");
            if (localData) {
                var jsonData = localData;
                dispatch(cvlData({
                    pan: jsonData.panNo,
                    nameAsOnPan: jsonData.nameAsOnPan
                }))
            }
            var guestData = localStorage.getItem('isGuest');
            if (guestData) {
                var guestJsonData = JSON.parse(guestData);
            }
        }

        let getNavbar = document.querySelectorAll('.navbarTop .nav-item');

        const mouseOverListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodes', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.add('show');
                el.classList.add('show');
            }
        }

        const mouseOutListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodesover', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.remove('show');
                el.classList.remove('show');
            }
        }

        const mouseClickListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodesover', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.remove('show');
                el.classList.remove('show');
            }
        }

        getNavbar.forEach((el) => {
            getNavbar.forEach((el) => {
                el.addEventListener('mouseover', (curr) => mouseOverListener(curr, el));
                el.addEventListener('mouseout', (curr) => mouseOutListener(curr, el));
                el.addEventListener('click', (curr) => mouseClickListener(curr, el));
            })
        })

        try {
            let panNo = stateData['cvlData']['pan'];

            dispatch(getCartCount({
                apiName: "GetCartCount",
                body: {
                    arnCode: "",
                    panNo: panNo,
                }
            }))
        } catch (error) { }

        return (() => {
            if (getNavbar) {
                getNavbar?.forEach?.((el) => {
                    el.removeEventListener('mouseover', (curr) => mouseOverListener(curr, el));
                    el.removeEventListener('mouseout', (curr) => mouseOutListener(curr, el));
                    el.removeEventListener('click', (curr) => mouseClickListener(curr, el));
                })
            }
        })
    }, [])

    const gotoContactUs = () => {
        // window.location.href = "/mutualfund/contact-us";
        history.push("/contact-us");
    }


    var customerName = "";


    if (stateData['cvlData'] !== null) {
        customerName = stateData['cvlData']['nameAsOnPan'];
    }


    let pendingCount = 0;
    console.log("stateData['cartCountData']", stateData['cartCountData']);
    if (stateData['cartCountData'] !== null && stateData['cartCountData'] !== undefined) {
        if (stateData['cartCountData'].hasOwnProperty('pendingCount')) {
            pendingCount = stateData['cartCountData']['pendingCount'];
        }
    }

    useEffect(() => {
        if (ClientType !== "") {
            if (ClientType == "BOTH") {
                document.body.classList.add('clientType_body');
            }
        }
    }, [ClientType])


    console.log(isBoth, 'isBoth')


    let isBoth = false;
    if (ClientType == "BOTH") {
        isBoth = true;
    }

    const fetchUserInfo = async () => {
    try {
        const response = await api.getUsetInfo();      
        const { success, data = {} } = response?.data || {};
        if (success) {
            console.log("UserInfo from API:", data);
            // remove existing key first
            localStorage.removeItem("userInfo");
            setEncryptedItem("userInfo", data);
            dispatch(cvlData({
                pan: data?.paN_NO,
                nameAsOnPan: data?.clientName
            }))
            console.log("After setEncryptedItem, localStorage:", localStorage.getItem("userInfo"));
        } else {
            console.log("API call failed:", response);
        }
        } catch (error) {
        console.error("Error fetching user info:", error);
        }
    }
    
    useEffect(() => {
        fetchUserInfo();
    }, [])

    return (
        <React.Fragment>
            <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row remove_navbar-height ">
                <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                    {/* <a className="navbar-brand brand-logo" href="/mutualfund/quickbuy"> */}

                    <a className="navbar-brand brand-logo" href="/mutualfund/login">
                        {/* <img src="assets/images/logo.svg" alt="logo" /> */}
                        {/* <Image image="nav/logo-momf.png" alt="logo" /> */}
                        <Image image="nav/mo_logo.png" alt="logo" style={{ marginTop: '8px' }} />

                    </a>
                    {/* <a className="navbar-brand brand-logo-mini" href="/mutualfund/quickbuy"> */}

                    <a className="navbar-brand brand-logo-mini" href="/mutualfund/login">
                        <Image image="nav/mf-m-min-logo.svg" alt="logo" />
                        {/* <img src="assets/images/logo-mini.svg" alt="logo" /> */}
                    </a>
                </div>
                {/* <div>View More Funds</div> */}
                <div className="navbar-menu-wrapper d-flex align-items-stretch">
                    <span ref={props.navbarViewMoreFundsRef} className={'navbar-view-funds-container'}>
                        {/* <button className="qbuy-btn view-more-funds">View More Funds</button> */}
                    </span>

                    <ul className="navbar-nav navbar-nav-right navbarTop">

                        {/* <li className="nav-item ">
                            <Link to="/Cart" className="nav-link count-indicator " id="cartDropdown">
                                <i className="mdi mdi-cart-outline"></i>

                                <span class="badge badge-up badge-pill">{pendingCount}</span>
                            </Link>
                        </li> */}

                        <li className="nav-item nav-profile dropdown">
                            <a className="nav-link dropdown-toggle quickyBuy" id="profileDropdown"
                                onClick={handleShow} data-toggle="dropdown" aria-expanded="false">
                                <div className="nav-profile-img" >
                                    <Image image="nav/profile-icon.png" alt="image" />
                                </div>
                                <div className="nav-profile-text">
                                    <p className="mb-1 text-black">{customerName}</p>
                                </div>
                            </a>
                            <div className={`dropdown-menu navbar-dropdown dropdown-menu-right p-0 border-0 font-size-sm ${show ? 'show' : ""}`} aria-labelledby="profileDropdown" data-x-placement="bottom-end">
                                <div className="p-2">

                                    {/* <h5 onClick={closePOpUp} className="dropdown-header text-uppercase pl-2 text-dark">User Options</h5>

                                    <a className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu" onClick={gotoContactUs}>
                                        <span>Contact Us</span>
                                        <span className="p-0">
                                        </span>
                                    </a>
                                    <a onClick={closePOpUp} className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu" href="/mutualfund/portfolio">
                                        <span>My Portfolio</span>
                                        <span className="p-0">
                                            <i className="mdi mdi-account-outline ml-1"></i>
                                        </span>
                                    </a>
                                    <a onClick={gotoResetPasscode}
                                        className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu"
                                    >
                                        <span>Reset Passcode</span>
                                        <span className="p-0">
                                            <i className="mdi mdi-lock-reset ml-1"></i>
                                        </span>
                                    </a>

                                    <div role="separator" className="dropdown-divider"></div> */}

                                    <h5 className="dropdown-header text-uppercase  pl-2 text-dark mt-2">Actions</h5>
                                    <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={handleLogout}>
                                        <span>Log Out</span>
                                        <i className="mdi mdi-logout ml-1"></i>
                                    </a>

                                </div>
                            </div>
                        </li>

                    </ul>

                </div>
            </nav>
        </React.Fragment>
    )
}

export default Navbar